import { NgModule } from '@angular/core';
import { MatIconSizeDirective } from './mat-icon-size.directive';

const DIRECTIVE = [MatIconSizeDirective];

@NgModule({
	declarations: [DIRECTIVE],
	imports: [],
	exports: [DIRECTIVE],
})
export class MatIconSizeModule {}
